export const wsRoute = process.env.REACT_APP_WSROUTE;
export const baseUrl = process.env.REACT_APP_API_BASEURL;
export const cognitoUserPoolId = process.env.REACT_APP_COGNITO_USER_POOL_ID;
export const cognitoClientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
export const timeIntervalPerMinute = 1;